const curatorFieldTitles: Readonly<Record<string, string>> = {
  title: "Title",
  candidateTitle: "Candidate Title",
  objectType: "Object or Work Type",
  objectWorkTypes: "Object or Work Types",
  materials: "Materials",
  technique: "Technique",
  techniques: "Techniques",
  support: "Support",
  supports: "Supports",
  subject: "Subject",
  subjectsAndIconography: "Subjects and Iconography",
  style: "Style",
  stylesAndMovements: "Styles and Movements",
  publicDiscoveryTags: "Discovery Words",
  discoveryTerms: "Discovery Terms",
  description: "Gallery Description",
  catalogNarrative: "Catalog Narrative",
  publicExcerpt: "Short Public Excerpt",
  visibleCondition: "Visible-Condition Wording",
  visibleConditionWording: "Visible-Condition Wording",
  missingInformation: "Questions to Check Later"
};

const acronyms: Readonly<Record<string, string>> = {
  ai: "AI",
  api: "API",
  eaf: "EAF",
  id: "ID",
  ids: "IDs",
  jpeg: "JPEG",
  jpg: "JPG",
  lg: "LG",
  llc: "LLC",
  md: "MD",
  png: "PNG",
  sm: "SM",
  uri: "URI",
  url: "URL",
  webp: "WebP",
  xl: "XL"
};

const minorWords = new Set([
  "and",
  "as",
  "at",
  "by",
  "for",
  "from",
  "in",
  "of",
  "on",
  "or",
  "the",
  "to",
  "with"
]);

export function curatorFieldTitle(value: string): string {
  return curatorFieldTitles[value] ?? formatMachineLabel(value);
}

export function formatMachineLabel(value: string): string {
  return value
    .trim()
    .split(/\s*:\s*/)
    .map(formatSegment)
    .filter(Boolean)
    .join(": ");
}

function formatSegment(value: string): string {
  const words = value
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .split(" ")
    .filter(Boolean);

  return words
    .map((word, index) => {
      const lower = word.toLocaleLowerCase();
      if (acronyms[lower]) return acronyms[lower];
      if (index > 0 && minorWords.has(lower)) return lower;
      return `${lower.charAt(0).toLocaleUpperCase()}${lower.slice(1)}`;
    })
    .join(" ");
}
